import { SceneSprite } from "GameObjects/StoryGame/SceneSprite";
import { TimelineLite } from "gsap";
import * as HLF from "html-living-framework";

export class Emoji extends SceneSprite {
    constructor(texture?: string | PIXI.Texture, anchor?: PIXI.IPoint) {
        super(texture, anchor);
        this.visible = false;
    }

    FadeOut() {
        // intentionally did not call super.FadeOut()
        this.interactive = false;
        this.visible = false;
        this.buttonMode = false;
        this.accessible = false;
    }
}